import { render, staticRenderFns } from "./ClientDownloadHub.vue?vue&type=template&id=12787318&scoped=true&"
import script from "./ClientDownloadHub.vue?vue&type=script&lang=js&"
export * from "./ClientDownloadHub.vue?vue&type=script&lang=js&"
import style0 from "./ClientDownloadHub.vue?vue&type=style&index=0&id=12787318&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12787318",
  null
  
)

export default component.exports